import React from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import { Row, Col } from 'react-bootstrap';
import EarlyAccessBenefits from '../../Presale/IconBox/EarlyAccessBenefits';
import ExclusivePricing from '../../Presale/IconBox/ExclusivePricing';
import PotentialForGrowth from '../../Presale/IconBox/PotentialForGrowth';
import TrustAndTransparency from '../../Presale/IconBox/TrustAndTransparency'





const IconBox = () => {


    return (
        <div className='pt-5 pb-5'>
            <Row>
                <Col lg={3} md={6} xs={12}>
                    <div className='icon_box'>
                        <EarlyAccessBenefits />
                        <h4 className="text-uppercase text-primary"><b>Exclusive <br />Pricing </b></h4>
                    </div>
                </Col>
                <Col lg={3} md={6} xs={12}>
                    <div className='icon_box'>
                        <ExclusivePricing />
                        <h4 className="text-uppercase text-primary"><b>Early Access <br/>Benefits </b></h4>
                    </div>
                </Col>
                <Col lg={3} md={6} xs={12}>
                    <div className='icon_box'>
                        <PotentialForGrowth />
                        <h4 className="text-uppercase text-primary"><b>Potential <br/>for Growth </b></h4>
                    </div>
                </Col>
                <Col lg={3} md={6} xs={12}>
                    <div className='icon_box'>
                        <TrustAndTransparency />
                        <h4 className="text-uppercase text-primary"><b>Trust and <br/>Transparency </b></h4>
                    </div>
                </Col>

            </Row>

        </div>
    );
}

export default IconBox
